import { c as _c } from "react/compiler-runtime";
import { VStack } from '@chakra-ui/react';
import { AcquisitionsBlock } from '@src/components/sco/About/AcquisitionsBlock';
import { CustomerSuccessBlock } from '@src/components/sco/About/CustomerSuccessBlock';
import { HistoryBlock } from '@src/components/sco/About/HistoryBlock';
import { LeadershipBlock } from '@src/components/sco/About/LeadershipBlock';
import { MissionBlock } from '@src/components/sco/About/MissionBlock';
import { Hero } from '@src/components/sco/LayoutBlocks/Hero';
import SectionWrapper from '@src/components/sco/LayoutBlocks/SectionWrapper';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
export const AboutLP: React.FC = () => {
  const $ = _c(8);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const isMobile = getBreakpointValue([true, true, false, false, false]);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Hero configKey="aboutLanding" heroBoxProps={{
      paddingBottom: 0,
      bgColor: "colorPalette.panel"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = isMobile ? 2 : 10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MissionBlock />;
    t3 = <LeadershipBlock />;
    t4 = <HistoryBlock />;
    t5 = <CustomerSuccessBlock />;
    t6 = <AcquisitionsBlock />;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t1) {
    t7 = <VStack align="stretch" gap={0} height="full" justify="stretch" width="full">{t0}<SectionWrapper bgColor="colorPalette.panel" gap={t1}>{t2}{t3}{t4}{t5}{t6}</SectionWrapper></VStack>;
    $[6] = t1;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
};